// Ordered list of pillar article slugs shown on the homepage.
export const articleSlugs: string[] = [
  "basetao-spreadsheet-guide",
  "basetao-review",
  "is-basetao-legit",
  "basetao-shipping-cost",
  "basetao-shipping-guide",
  "basetao-coupon-discount-code",
  "basetao-warehouse-guide",
  "basetao-qc-guide",
  "basetao-safety-guide",
  "basetao-buying-guide",
  "basetao-seller-guide",
];